import React, {useEffect, useState} from 'react';
import {Card} from "../../../../components/card/card.jsx";
import ModalPassage from "./selected-passages-components/modal-passage.jsx";
import SelectedPassageRow from "./selected-passages-components/selected-passage-row.jsx";
import SelectedPassagesButtons from "./selected-passages-components/selected-passages-buttons.jsx";
import axios from "axios";
import projectUtils from "../../../../utils/project-utils.js";
const API_URL = import.meta.env.VITE_API_URL;

const SelectedPassage = ({passage,passages, selectedIndex, sideImage, plate, vehicleDetails, clickedResult, show, setShow}) => {
    const [deviceInfo, setDeviceInfo] = useState([])

    useEffect(() => {
        setDeviceInfo([])

        const getPassageMetadata = () => {
            const procid = passage.id;
            const dateTime = passage.utcCaptureTime

            const formData = new FormData();
            formData.append('procid', procid);
            formData.append('date', dateTime);

            if (!procid || !dateTime) {
                return;
            }

            axios.post(`${API_URL}/corporationSearch/passageDetails`, formData)
                .then(response => {
                    const data = response.data.data;

                    if (!data || !data.procmetadados) {
                        return;
                    }

                    let metaData = JSON.parse(data.procmetadados);
                    if (!metaData?.deviceinfo) return
                    setDeviceInfo([{
                        username: metaData.deviceinfo.username,
                        phone: metaData.deviceinfo.phone,
                        lat: metaData.loc.lat,
                        lng: metaData.loc.lng,
                    }]);
                })
                .catch(error => {
                    console.error(error);
                    projectUtils.swalErrorMessage('', "Erro ao realizar pesquisa", 'Ok');
                });

        }

        getPassageMetadata();
    }, [passage]);

    return (
        <>
            <div className={"col-span-3"}>
                {
                    passage && Object.keys(passage).length > 0 &&
                    <>
                        <Card className={"border border-[#dcdcdc]! mt-2"}>
                            <Card.Body>
                                <SelectedPassagesButtons passages={passages} passage={passage} clickedResult={clickedResult} selectedIndex={selectedIndex}/>

                                <div className="flex flex-col w-full">
                                    <div id="view-div" className="w-full">
                                        <div className="flex flex-col w-full">
                                            <div className="text-center flex justify-center items-center gap-2" id="lane-clone">
                                                <img
                                                    src={`${API_URL}/public/assets/img/sentry_lane/${passage?.lane.type}.png`}
                                                    alt="Lane Type"
                                                />
                                                <span dangerouslySetInnerHTML={{ __html: passage?.lane.name }} />
                                            </div>

                                            <hr className="border-0 h-px bg-gradient-to-r from-transparent via-[#a2a4a5] to-transparent mt-0 mb-[3px]" />

                                            <div className="text-center mb-[3px] vehicle-date-passage">
                                                {passage.captureTime}
                                            </div>

                                            <div className="product-imitation !h-[290px]">
                                                <img
                                                    src={`${API_URL+ "/" + sideImage}`}
                                                    className="img-passage w-full h-full object-contain cursor-zoom-in"
                                                    onClick={() => setShow(true)}
                                                    alt="Passagem"
                                                />
                                            </div>

                                            <div className="flex justify-around product-desc mt-2">
                                                <div className="vehicle-plate">
                                                    <div className={`product-heading ${passage?.plate.pattern ?? 'WITHOUT_PATTERN'}`}></div>
                                                    <div className={`product-body ${passage?.plate.pattern ?? 'WITHOUT_PATTERN'}`}>
                                                        {plate}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="w-full overflow-auto h-full mt-4">
                                    <table className="w-full text-left border-collapse">
                                        <tbody>
                                            <SelectedPassageRow title={true} titleLabel={"Dados do veículo"} />
                                            <SelectedPassageRow label={"Marca/Modelo"} value={vehicleDetails?.brandModel || ''} />
                                            <SelectedPassageRow label={"Ano"} value={vehicleDetails?.modelYear > 0 ? vehicleDetails.modelYear : ''} />
                                            <SelectedPassageRow label={"Cor"} value={vehicleDetails?.color || ''} />
                                            <SelectedPassageRow label={"RENAVAM"} value={vehicleDetails?.renavam || ''} />
                                            <SelectedPassageRow label={"Chassi"} value={vehicleDetails?.engineNumber || ''} />
                                            <SelectedPassageRow label={"Motor"} value={vehicleDetails?.brandModel || ''} />
                                            <SelectedPassageRow label={"Tipo (Denatran)"} value={vehicleDetails?.vehicleTypePrf || ''} />
                                            <SelectedPassageRow label={"CPF/CNPJ"} value={vehicleDetails?.ownerCpfCnpj || ''} />
                                            <SelectedPassageRow label={"Município"} value={vehicleDetails?.cityDistrict || ''} />
                                        </tbody>
                                    </table>

                                    {deviceInfo.length > 0 &&
                                        <table className="w-full text-left border-collapse">
                                            <tbody>
                                            <SelectedPassageRow title={true} titleLabel={"Dados do dispositivo"} />
                                            {deviceInfo[0]?.username && (
                                                <SelectedPassageRow label={"Usuário"} value={deviceInfo[0].username} />
                                            )}
                                            {deviceInfo[0]?.phone && (
                                                <SelectedPassageRow label={"Número"} value={deviceInfo[0].phone} />
                                            )}
                                            {(deviceInfo[0]?.lat && deviceInfo[0]?.lng) && (
                                                <>
                                                    <SelectedPassageRow label={"Latitude"} value={deviceInfo[0].lat} />
                                                    <SelectedPassageRow label={"Longitude"} value={deviceInfo[0].lng} />
                                                </>
                                            )}
                                            </tbody>
                                        </table>
                                    }
                                </div>

                            </Card.Body>
                        </Card>

                        <ModalPassage passage={passage} show={show} setShow={setShow} plate={plate} sideImage={sideImage} />
                    </>
                }
            </div>
        </>
    );
};

export default SelectedPassage;